<div class="study-container">
  <div class="study-gameplay-container">
    @defer(when isReady) { <gameplay-player [style.height]="'100%'" [(useTSX)]="useTSX" [toolbar]="toolbar" [setting]="setting" [card]="card" [didAnswer]="didAnswer" [progress]="progress" [isAutoplay]="isAutoplay" (selected)="onSelect($event)" (action)="onAction($event)" [rightAnswerDisplayTime]="rightAnswerTime" [wrongAnswerDisplayTime]="wrongAnswerTime"></gameplay-player> }
    @placeholder { <nx-superprep-dot-flashing></nx-superprep-dot-flashing> }
<!--
    @if (isWhisper) {
      <study-lesson-whisper [card]="card" [didAnswer]="didAnswer" [(selected)]="selected"></study-lesson-whisper>
    }
-->
  </div>
  <ng-template [ngTemplateOutlet]="_slidingRightTemplate"></ng-template>
</div>

<ng-template #_slidingRightTemplate>
  @if (isSlideVisible) {
    <div
      class="study-sliding-right-container" [@slideInRightOnEnter] [@slideOutRightOnLeave]
      cdkDrag cdkDragBoundary=".study-container"
    >
      <div class="drag__handle" cdkDragHandle>
        <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
          <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
          <path d="M0 0h24v24H0z" fill="none"></path>
        </svg>
      </div>
      <div class="study-sliding-right-content">
        <study-info [reposition]="reposition"></study-info>
      </div>
    </div>
  }
</ng-template>

@if (loadingProgress < 100) {
  <div class="floating-progress-bar">
    <mat-progress-bar mode="determinate" [value]=loadingProgress></mat-progress-bar>
  </div>
}
<div id='_hidden' hidden></div>
